import { render, staticRenderFns } from "./HelpResources.vue?vue&type=template&id=59c61c7d&scoped=true"
import script from "./HelpResources.vue?vue&type=script&lang=js"
export * from "./HelpResources.vue?vue&type=script&lang=js"
import style0 from "./HelpResources.vue?vue&type=style&index=0&id=59c61c7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c61c7d",
  null
  
)

export default component.exports